import { SEARCH_PAGE_PREFIXES } from '#shared/constants';

export default function getSearchPrefix() {
  const envProps = useEnvProps();
  const navKillswitch = useNavKillswitch();

  const { killswitches } = navKillswitch;
  const { isMcom } = envProps;

  if (isMcom) {
    return SEARCH_PAGE_PREFIXES.featured;
  }

  return killswitches.useCommonSearchPageUrlPattern ? SEARCH_PAGE_PREFIXES.featured : SEARCH_PAGE_PREFIXES.keyword;
}
